export default "__VITE_ASSET__CIe3fqE0__"